module.exports = __webpack_public_path__ + "img/SKMJ_lift1.27829d17.jpg";